import { useContext } from 'react';
import { SharedMailboxContext, SharedMailboxContextType } from '../contexts';

export const useShareMailboxContext = (): SharedMailboxContextType =>
  useContext(SharedMailboxContext);
